import {call, put, select} from "typed-redux-saga";
import {globalError, fetchContestStatSuccess} from "modules/actions";
import {
	ApiError,
	TriviaApi,
} from "modules/utils";
import {getLastGameContest} from "modules/selectors";

export const fetchContestStatSaga = function* () {
	try {
		const last_completed_contest = yield* select(getLastGameContest);
		if (!last_completed_contest) {
			return;
		}
		const response = yield* call(TriviaApi.stats.contest, last_completed_contest.id);
		ApiError.CHECK(response);
		yield put(fetchContestStatSuccess(response.result));
	} catch (e: any) {
		yield put(globalError(e))
	}
};
